import axios from "axios";

export const createRequest = <T extends any, R extends any>(doc: T) => {
  return async (url: string) => {
    const response = await axios.post(url, doc);
    const data = response.data;
    return data.data as R;
  };
};
